import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";

const formatAmount = (amount: number) => `$${Math.abs(amount).toLocaleString()}`;

export const getFreelancerNotificationTitle = (
  notification: INotification
): string | undefined => {
  const { type, afterData } = notification;

  switch (type) {
    case notificationEnums.FreelancerNotificationType.FREELANCER_PAYMENT_CREATED:
      if (afterData && 'amount' in afterData) {
        return `New payment: ${formatAmount(afterData.amount)}`;
      }
      return "New payment created";
    
    case notificationEnums.FreelancerNotificationType.FREELANCER_PAYMENT_UPDATED:
      if (afterData && 'amount' in afterData && 'status' in afterData) {
        return `Payment updated: ${formatAmount(afterData.amount)} - ${afterData.status}`;
      }
      return "Payment updated";

    case notificationEnums.FreelancerNotificationType.FREELANCER_PROJECT_ASSIGNMENT_CREATED:
      if (afterData && 'projectName' in afterData) {
        return `New assignment: ${afterData.projectName}`;
      }
      return "New project assignment";

    case notificationEnums.FreelancerNotificationType.FREELANCER_PROJECT_ASSIGNMENT_COMPLETED:
      if (afterData && 'projectName' in afterData) {
        return `Assignment completed: ${afterData.projectName}`;
      }
      return "Project assignment completed";

    case notificationEnums.FreelancerNotificationType.FREELANCER_AGREEMENT_CREATED:
      return "New independent engineer agreement requires signature";

    case notificationEnums.FreelancerNotificationType.FREELANCER_AGREEMENT_REMINDER:
      return "Please sign your independent engineer agreement";

    case notificationEnums.FreelancerNotificationType.FREELANCER_ONBOARDING_COMPLETE:
      return "Welcome! Your onboarding is complete";

    default:
      return undefined;
  }
}; 